import { Component, OnInit, Input } from '@angular/core';
import { PlanDetailsRenderableGroup } from '../../../../types/plan-details.types';

@Component({
    selector: 'app-plan-documents',
    templateUrl: './plan-documents.component.html',
    styleUrls: ['./plan-documents.component.scss'],
    standalone: false
})
export class PlanDocumentsComponent implements OnInit {
  @Input() benefitGroup: PlanDetailsRenderableGroup;

  constructor() { }

  ngOnInit() {
  }

}
